import { useEffect, useState } from 'react';

export type SignageOrientation = 'landscape' | 'portrait';

/**
 * Signage screens don't resize after mount, but a rotated screen must still be
 * right on reload, and some players fire a resize on rotation, so we listen
 * for changes anyway.
 */
export function useSignageOrientation(): SignageOrientation {
  const [orientation, setOrientation] = useState<SignageOrientation>(() =>
    window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape');

  useEffect(() => {
    const query = window.matchMedia('(orientation: portrait)');
    const onChange = (e: MediaQueryListEvent) => setOrientation(e.matches ? 'portrait' : 'landscape');
    if (query.addEventListener) {
      query.addEventListener('change', onChange);
      return () => query.removeEventListener('change', onChange);
    }
    // Older WebViews on signage players only have the deprecated API.
    query.addListener(onChange);
    return () => query.removeListener(onChange);
  }, []);

  return orientation;
}
